import { LISTAR_CENTRO_DE_CUSTOS, LISTAR_CENTRO_DE_CUSTO_SELECIONADO } from './mutation-types'

export default {
  [LISTAR_CENTRO_DE_CUSTOS]: (state, centroDeCustos) => {
    state.centroDeCustos = centroDeCustos
  },
  [LISTAR_CENTRO_DE_CUSTO_SELECIONADO]: (state, centroDeCusto) => {
    state.centroDeCustoSelecionado = centroDeCusto
  },
}
